import React , { useEffect, useRef }from "react";
import { Helmet } from "react-helmet";

const Home = () => {
  const dfMessengerRef = useRef(null);
  useEffect(() => {
    // Se ejecuta cuando el componente se monta y cada vez que 'userName' cambia.
    
    // Nos aseguramos de que la referencia al df-messenger exista
    // y de que tengamos un nombre de usuario para enviar.
    if (dfMessengerRef.current) {
      // Esta es la función clave: le pasa los parámetros al chatbot.
      // La clave 'user_name' debe coincidir con el nombre del parámetro
      // que definiste en tu agente de Dialogflow.
      dfMessengerRef.current.setQueryParameters({ asesor: "" });
    }
  }, ["Pedronel"]);
  return (
    <>
      <Helmet>
        <title>Asistente</title>
      </Helmet>
      <df-messenger 
        ref={dfMessengerRef} 
        project-id="findai-459812" agent-id="83895d4e-07f2-4540-8929-50f6a39a2a3b" language-code="es"
        max-query-length="-1">
        <df-messenger-chat chat-title="FindAI asistente de soporte">
        </df-messenger-chat>
      </df-messenger>
    </>
  );
};

export default Home;
